import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { HashRouter } from 'react-router-dom';

import { App } from 'src/App';
import { installTheme } from 'src/lib/theme';
import 'src/styles/base.css';
import 'src/styles/components.css';
import 'src/styles/reader.css';

// Before the first paint, and independently of which screen renders a toggle.
installTheme();

const root = document.getElementById('root');
if (!root) throw new Error('#root is missing from index.html');

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // A completed broadcast is immutable; refetching it on every window focus is pure noise.
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

// HashRouter, not BrowserRouter: the dashboard is a static bundle on an S3 website endpoint, which
// answers a deep link with a 404 plus index.html. Hash routing needs no bucket or CDN rewrite rule.
createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <HashRouter>
        <App />
      </HashRouter>
    </QueryClientProvider>
  </StrictMode>
);
